import Modal from "../../../../common/ui/modal";

const DeleteShape = ({shapeDetail, removeShape, shapeDetailIndex}) => {
    return (
        <>
            <Modal
                showButtonLabel={"Delete"}
                title="Delete Shape"
                content={[{
                    text: `Are you sure you wish to delete the below Shape?`,
                    classes: ""
                }, {
                    text: `${shapeDetail?.key}`,
                    classes: "text-blue font-bold text-center"
                }]}
                confirmButtonLabel="Confirm Delete"
                showIcon={false}
                handleConfirm={() => {
                    removeShape(shapeDetail, shapeDetailIndex)
                }}
            />
        </>
    )
}

export default DeleteShape
